export const blockIconsActionVisibilityOff = (
	<span className='material-symbols-outlined'>visibility_off</span>
);
